import { CommunicationSubmission } from "../types";

type WasteSubmissionItem = {
  submissionId?: string | null;
  title: string | null;
  submissionType?: string | null;
  submissionStatus: string;
  tenantId: string;
};

function toCommunicationSubmission(
  row: WasteSubmissionItem
): CommunicationSubmission | null {
  if (!row.submissionId) return null;
  return {
    id: row.submissionId,
    title: row.title ?? "",
    submissionType: row.submissionType ?? undefined,
    status: row.submissionStatus ?? undefined,
  } as CommunicationSubmission;
}

export function mapWasteSubmissionRowsToCommunicationSubmissions(
  items: WasteSubmissionItem[]
): CommunicationSubmission[] {
  return items
    .map(toCommunicationSubmission)
    .filter((s): s is CommunicationSubmission => s !== null);
}
